import Rangliste from "./Rangliste";
import "./JahrUebersicht.css";

/**
 * Jahres-Runde ausgewertet: das richtige Jahr gross, darunter alle Tipps
 * mit Abstand und wer den Punkt bekommt. Wer nicht getippt hat, steht
 * unten mit "kein Tipp". Gleich auf Host und Handys.
 * spieler: [{ id, name }] aller Mitspieler (fuer "kein Tipp"), optional.
 * @category spiel
 */
export function JahrUebersicht({ ergebnis, meineId, farbe, spieler = [] }) {
  if (!ergebnis) return null;
  const gewinner = ergebnis.winners || [];
  const tipps = [...(ergebnis.entries || [])].sort((a, b) => a.diff - b.diff);
  let platz = 0;
  let vorher = null;
  const eintraege = tipps.map((e, i) => {
    if (e.diff !== vorher) {
      platz = i + 1;
      vorher = e.diff;
    }
    return {
      key: e.playerId,
      name: e.name,
      platz,
      wert: e.year,
      unterzeile: e.diff === 0 ? "genau richtig" : e.diff === 1 ? "1 Jahr daneben" : `${e.diff} Jahre daneben`,
      sieg: gewinner.includes(e.playerId),
      plus: gewinner.includes(e.playerId) ? 1 : null,
      ich: e.playerId === meineId,
    };
  });
  const getippt = new Set(tipps.map((e) => e.playerId));
  spieler
    .filter((p) => !getippt.has(p.id))
    .forEach((p) =>
      eintraege.push({ key: p.id, name: p.name, platz: null, wert: null, unterzeile: "kein Tipp", ich: p.id === meineId })
    );

  return (
    <div className="jahr-auswertung">
      <div className="jahr-gross">
        <span className="ueberzeile">Richtig war</span>
        <b>{ergebnis.correctYear}</b>
      </div>
      <Rangliste eintraege={eintraege} farbe={farbe} leerText="Niemand hat getippt." />
    </div>
  );
}

export default JahrUebersicht;
